export function toggleLanguage(language){    
    return {type:"TOGGLE_LANGUAGE", language}
}

export const fetchLanguage = () => {
    return 'en';
};